const RequestHeaders = {
  HttpJwtToken: 'x-http-jwt-token',
  Authorization: 'Authorization',
  AccountId: 'X-Account-Id',
  KontentinoBlogWordpressBasicAuthentication: 'Authorization',
};

export default RequestHeaders;
